"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const ArrowRight = ({ size = 16, fill = "#fff", name = "Arrow right", ...rest }) => {
    return (react_1.default.createElement("svg", { width: size, height: size, viewBox: `0 0 16 16`, fill: fill, ...rest },
        react_1.default.createElement("title", null, name),
        react_1.default.createElement("path", { d: "M8,12V9H2V7h6V4l6,4L8,12z" })));
};
exports.default = ArrowRight;
//# sourceMappingURL=index.js.map